export const Features = {
    portal: {
        key: 'portal.enabled',
        fallback: true,
    },
    internalLogin: {
        key: 'local.login.enabled',
        fallback: false,
    },
    externalLogin: {
        key: 'external.login.enabled',
        fallback: true,
    },
    passwordReset: {
        key: 'password.reset.enabled',
        fallback: false,
    },
    rdarr: {
        key: 'rdarr.enabled',
        fallback: false,
    },
    ewis: {
        key: 'ewis.enabled',
        fallback: false,
    },
    indicators: {
        key: 'indicators.enabled',
        fallback: false,
    },
    riskCulture: {
        key: 'riskCulture.enabled',
        fallback: false,
    },
    riskAppetite: {
        key: 'riskAppetite.enabled',
        fallback: false,
    },
    landingPageRotation: {
        key: 'landingpage.rotation.enabled',
        fallback: false,
    },
    defaults: {
        maxFileSizeMb: {
            key: 'defaults.files.maxSizeMb',
            fallback: 25,
        },
    },
};
